import React, { useRef } from 'react';

import ModalAiArtist from './ModalAiArtist';

import AlvaroBImg from '../../../../../Images/gallery/ai-services/alvaro-c.png';
import Video1 from '../../../../../Images/gallery/ai-services/alvaro-c/video-1.png';
import Video2 from '../../../../../Images/gallery/ai-services/alvaro-c/video-2.png';
import Video3 from '../../../../../Images/gallery/ai-services/alvaro-c/video-3.png';

import {
  AlvaroC_Title,
  AlvaroC_Text,
  AlvaroC_Video1,
  AlvaroC_Video2,
  AlvaroC_Video3,
} from '../../../../../utils/ES/Modals/aiArtists';

const ModalALvaroC = () => {
  return (
    <>
      <ModalAiArtist
        id="artist-alvaro-c"
        artistImage={AlvaroBImg}
        artistName="Álvaro C"
        artistTitle={AlvaroC_Title}
        artisText={AlvaroC_Text}
        videoRef1={'alvaro-video-1'}
        videoBg1={Video1}
        videoText1={AlvaroC_Video1}
        videoRef2={'alvaro-video-2'}
        videoBg2={Video2}
        videoText2={AlvaroC_Video2}
        videoRef3={'alvaro-video-3'}
        videoBg3={Video3}
        videoText3={AlvaroC_Video3}
      />
    </>
  );
};

export default ModalALvaroC;
